export default "__VITE_ASSET__ixl3TGQO__"